/*
 * Popup newsletter (sections/newsletter-popup.liquid).
 * - Parte solo dopo il banner iubenda (evento 'fc:cookie-ready' da layout/theme.liquid).
 * - Si apre dopo N secondi o a metà pagina, quello che arriva prima.
 * - Chiuso: non si ripropone per N giorni. Iscritta: mai più.
 * - Invio con POST normale (Shopify può chiedere il captcha): al ritorno, se l'invio
 *   era del popup, si riapre una volta con il messaggio di conferma o con l'errore.
 * - Nell'editor del tema si vede solo quando la sezione è selezionata.
 */
(function () {
  if (window.fcNewsletterPopup) return;

  var KEY_CLOSED = 'fc_nl_popup_closed_at';
  var KEY_SUBSCRIBED = 'fc_nl_popup_subscribed';
  var KEY_PENDING = 'fc_nl_popup_pending'; // sessionStorage: invio partito dal popup
  var PENDING_TTL = 15 * 60 * 1000;
  var DAY = 24 * 60 * 60 * 1000;
  var FORM_ID = 'NewsletterPopupForm';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';

  function storageGet(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }
  function storageSet(store, key, value) {
    try { window[store].setItem(key, value); } catch (e) {}
  }
  function storageRemove(store, key) {
    try { window[store].removeItem(key); } catch (e) {}
  }

  /* ---------- Banner cookie risolto? ---------- */

  /* Restituisce una funzione che annulla l'attesa */
  function whenCookieReady(cb) {
    var done = false;
    var timer = null;
    var started = Date.now();
    function stop() {
      done = true;
      window.removeEventListener('fc:cookie-ready', ready);
      if (timer) clearInterval(timer);
    }
    function ready() {
      if (done) return;
      stop();
      window.fcCookieReady = true;
      cb();
    }
    if (window.fcCookieReady) {
      ready();
      return stop;
    }
    window.addEventListener('fc:cookie-ready', ready);
    // Riserva: preferenza già espressa ma callback persa, oppure iubenda bloccato (adblock)
    timer = setInterval(function () {
      var api = window._iub && window._iub.cs && window._iub.cs.api;
      if (api && typeof api.isPreferenceExpressed === 'function') {
        if (api.isPreferenceExpressed()) ready();
      } else if (Date.now() - started > 8000) {
        ready();
      }
    }, 500);
    return stop;
  }

  /* ---------- Popup ---------- */

  function Popup(root) {
    this.root = root;
    this.dialog = root.querySelector('.nl-popup__dialog');
    this.form = root.querySelector('#' + FORM_ID) || root.querySelector('form');
    this.sectionId = root.getAttribute('data-section-id');
    this.delay = Math.max(0, parseInt(root.getAttribute('data-delay'), 10) || 8) * 1000;
    this.days = Math.max(1, parseInt(root.getAttribute('data-days'), 10) || 30);
    this.designMode = root.getAttribute('data-design-mode') === 'true' || !!(window.Shopify && window.Shopify.designMode);
    this.isOpen = false;
    this.success = false;
    this.lastFocus = null;
    this.cleanups = [];
    this.onKeydown = this.onKeydown.bind(this);
    this.bind();
  }

  Popup.prototype.listen = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    this.cleanups.push(function () { target.removeEventListener(type, fn, opts); });
  };

  Popup.prototype.destroy = function () {
    this.cleanups.forEach(function (fn) { fn(); });
    this.cleanups = [];
    if (this.isOpen) document.documentElement.classList.remove('nl-popup-open');
  };

  Popup.prototype.bind = function () {
    var self = this;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-nl-close]'), function (el) {
      el.addEventListener('click', function () { self.close(); });
    });
    this.dialog.addEventListener('keydown', this.onKeydown);
    if (this.form) {
      this.form.addEventListener('submit', function () {
        storageSet('sessionStorage', KEY_PENDING, String(Date.now()));
      });
    }
  };

  Popup.prototype.setView = function (view) {
    this.success = view === 'success';
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-nl-view]'), function (el) {
      el.hidden = el.getAttribute('data-nl-view') !== view;
    });
  };

  Popup.prototype.open = function () {
    if (this.isOpen) return;
    var self = this;
    this.isOpen = true;
    this.lastFocus = document.activeElement;
    this.root.hidden = false;
    document.documentElement.classList.add('nl-popup-open');
    // reflow, poi la transizione
    void this.root.offsetWidth;
    this.root.classList.add('is-open');
    var target = this.success
      ? this.root.querySelector('[data-nl-view="success"] .nl-popup__submit')
      : (this.root.querySelector('.nl-popup__input[aria-invalid="true"]') || this.root.querySelector('.nl-popup__input'));
    setTimeout(function () {
      try { (target || self.dialog).focus({ preventScroll: true }); } catch (e) { (target || self.dialog).focus(); }
    }, 60);
  };

  Popup.prototype.close = function () {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    this.root.classList.remove('is-open');
    document.documentElement.classList.remove('nl-popup-open');
    setTimeout(function () { if (!self.isOpen) self.root.hidden = true; }, 500);
    if (!this.designMode) {
      if (this.success) storageSet('localStorage', KEY_SUBSCRIBED, '1');
      else storageSet('localStorage', KEY_CLOSED, String(Date.now()));
    }
    if (this.lastFocus && typeof this.lastFocus.focus === 'function' && document.contains(this.lastFocus)) {
      try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  };

  Popup.prototype.onKeydown = function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      this.close();
      return;
    }
    if (e.key === 'Tab') {
      var items = Array.prototype.filter.call(this.dialog.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
    // Frecce/spazio non devono far scorrere le sezioni fullscreen della home sotto il popup
    e.stopPropagation();
  };

  /* Esito dell'ultimo invio: true se l'apertura è già decisa (successo/errore del popup) */
  Popup.prototype.handleSubmission = function () {
    var result = this.root.querySelector('[data-nl-result]');
    var posted = (result && result.getAttribute('data-posted') === 'true') || /[?&]customer_posted=true/.test(window.location.search);
    var hasErrors = result && result.getAttribute('data-has-errors') === 'true';
    var pendingAt = parseInt(storageGet('sessionStorage', KEY_PENDING), 10);
    var fromPopup = (pendingAt && Date.now() - pendingAt < PENDING_TTL) || window.location.hash === '#' + FORM_ID;
    // Il flag si consuma solo quando c'è un esito (non sulla pagina del captcha o altre pagine intermedie)
    if (posted || hasErrors) storageRemove('sessionStorage', KEY_PENDING);

    if (posted && !this.designMode) storageSet('localStorage', KEY_SUBSCRIBED, '1');

    if (fromPopup && posted) {
      this.setView('success');
      return true;
    }
    if (fromPopup && hasErrors) return true;

    // L'errore arriva da un altro modulo newsletter (footer, home): qui non va mostrato
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-nl-error]'), function (el) { el.remove(); });
    var email = this.root.querySelector('.nl-popup__input[aria-invalid]');
    if (email) {
      email.removeAttribute('aria-invalid');
      email.removeAttribute('aria-describedby');
    }
    return false;
  };

  Popup.prototype.shouldAutoShow = function () {
    if (storageGet('localStorage', KEY_SUBSCRIBED) === '1') return false;
    var closedAt = parseInt(storageGet('localStorage', KEY_CLOSED), 10);
    if (closedAt && Date.now() - closedAt < this.days * DAY) return false;
    return true;
  };

  Popup.prototype.scheduleAutoShow = function () {
    var self = this;
    var fired = false;
    function trigger() {
      if (fired) return;
      fired = true;
      self.cleanups.forEach(function (fn) { fn(); });
      self.cleanups = [];
      self.open();
    }
    this.cleanups.push(whenCookieReady(function () {
      if (fired) return;
      var timer = setTimeout(trigger, self.delay);
      self.cleanups.push(function () { clearTimeout(timer); });

      self.listen(window, 'scroll', function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.pageYOffset / max >= 0.5) trigger();
      }, { passive: true });

      // Home a sezioni fullscreen: niente scroll, conta la sezione raggiunta
      self.listen(document, 'fs:change', function (e) {
        var total = document.querySelectorAll('.fs-section').length;
        var index = e.detail && typeof e.detail.index === 'number' ? e.detail.index : 0;
        if (total > 1 && index / (total - 1) >= 0.5) trigger();
      });
    }));
  };

  Popup.prototype.init = function () {
    var openNow = this.handleSubmission();
    if (this.designMode) return;
    var self = this;
    if (openNow) {
      this.cleanups.push(whenCookieReady(function () { self.open(); }));
      return;
    }
    if (this.shouldAutoShow()) this.scheduleAutoShow();
  };

  /* ---------- Avvio + editor del tema ---------- */

  var instances = {};

  function setup(scope) {
    var roots = (scope || document).querySelectorAll('[data-nl-popup]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root._nlPopup) return;
      var popup = new Popup(root);
      root._nlPopup = popup;
      if (instances[popup.sectionId]) instances[popup.sectionId].destroy();
      instances[popup.sectionId] = popup;
      popup.init();
    });
    return roots;
  }

  function start() { setup(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:select', function (e) {
    var popup = instances[e.detail && e.detail.sectionId];
    if (popup) popup.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var popup = instances[e.detail && e.detail.sectionId];
    if (popup) popup.close();
  });
  document.addEventListener('shopify:section:load', function (e) {
    var roots = setup(e.target);
    // Ricaricata per una modifica nell'editor: la sezione è quella in lavorazione, la mostriamo
    if (roots.length) instances[e.detail.sectionId] && instances[e.detail.sectionId].open();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var popup = instances[e.detail && e.detail.sectionId];
    if (popup) {
      popup.destroy();
      delete instances[e.detail.sectionId];
    }
  });

  window.fcNewsletterPopup = { instances: instances };
})();
